import Axios from '../baseApi';

export default {
  async fetch() {
    return await Axios.get('/api-master-data/v1/accounting-lock');
  }
}
